// Accept legacy saved slots as well as the API's current moon marker.
const NEXT_DAY_MARKER = /(?:\(\+1\)|🌙\uFE0F?)\s*$/u;

/**
 * Resolve an availability date and raw slot into the actual appointment date/time.
 * Keep the raw selection in storage: the availability date may differ from the
 * appointment date. UTC getters/setters below perform calendar arithmetic only;
 * these values are outlet wall-clock times, not instants to convert to UTC.
 */
export const resolveBookingDateTime = (selectedDate, selectedTime) => {
  const originalSlot = typeof selectedTime === 'string' ? selectedTime : '';
  const isNextDay = NEXT_DAY_MARKER.test(originalSlot);
  const cleanTime = originalSlot.replace(NEXT_DAY_MARKER, '').trim();
  const match = cleanTime.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?$/i);
  let time = '';
  let displayTime = '';
  let slotLabel = '';

  if (match) {
    let hours = Number(match[1]);
    const minutes = Number(match[2]);
    const seconds = Number(match[3] || 0);
    const meridian = match[4]?.toUpperCase();
    const validHours = meridian ? hours >= 1 && hours <= 12 : hours <= 23;

    if (validHours && minutes <= 59 && seconds <= 59) {
      if (meridian) hours = hours % 12 + (meridian === 'PM' ? 12 : 0);
      const pad = (value) => String(value).padStart(2, '0');
      const hour12 = hours % 12 || 12;
      const period = hours >= 12 ? 'PM' : 'AM';
      time = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      displayTime = `${hour12}:${pad(minutes)} ${period}`;
      // Availability checks identify the slot under its original business date.
      slotLabel = `${pad(hour12)}:${pad(minutes)}${period}${isNextDay ? ' 🌙' : ''}`;
    }
  }

  let date = '';
  const dateMatch = typeof selectedDate === 'string'
    ? selectedDate.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/)
    : null;
  if (dateMatch) {
    const [day, month, year] = dateMatch.slice(1).map(Number);
    const calendar = new Date(0);
    calendar.setUTCHours(0, 0, 0, 0);
    calendar.setUTCFullYear(year, month - 1, day);

    // Reject invalid base dates instead of silently rolling them into a new month.
    if (calendar.getUTCFullYear() === year && calendar.getUTCMonth() === month - 1 && calendar.getUTCDate() === day) {
      if (isNextDay) calendar.setUTCDate(calendar.getUTCDate() + 1);
      date = [calendar.getUTCDate(), calendar.getUTCMonth() + 1, calendar.getUTCFullYear()]
        .map((value, index) => String(value).padStart(index === 2 ? 4 : 2, '0'))
        .join('-');
    }
  }

  return { date, time, displayTime, isNextDay, originalSlot, slotLabel };
};
